import React, {Component} from 'react'

import { ReactComponent as LogoIcon } from '../../../assets/images/icons/logo.svg'

import { getLocale } from '../../../helpers/util' 

type LoaderProps = {
    isLoading: boolean,
    classes: string,
    message: string
}

class Loader extends Component<LoaderProps> {
  static defaultProps = {
    classes: '',
    message: ''
  }

  render() {
    const { 
      isLoading, 
      classes, 
      message
    } = this.props

    let text = ''

    if (getLocale() === 'ru') {
      text = message ? message : 'Загрузка...'
    } else {
      text = message ? message : 'Loading...'
    }
    return (
      isLoading && (
        <React.Fragment>
          <div className={`loader-overlay ${classes}`} />
          <div className="loader">
            <LogoIcon />
            <div className="loader__text">{text}</div>
          </div>
        </React.Fragment>
      )
    )
  }
}

export default Loader
